var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#074673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "T_C",
    "data-name": "T&C",
    transform: "translate(-398.25 -314.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "start-event-condition",
    d: "M6.886,6.216v6.527h5.188V6.216H6.886Zm.417.419h4.351v5.689H7.3Zm.449.64v.417h3.453V7.276Zm0,1.26v.419h3.453V8.536Zm0,1.456v.417h3.453V9.992Zm0,1.316v.417h3.453v-.417Z",
    transform: "translate(395.78 311.78)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M10.375,3.375a7,7,0,1,0,7,7A7,7,0,0,0,10.375,3.375Zm0,13.418a6.418,6.418,0,1,1,6.418-6.418A6.425,6.425,0,0,1,10.375,16.793Z",
    transform: "translate(394.875 310.875)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTc);
export default __webpack_public_path__ + "static/media/T&C.9d27bf843c62ea42742ff354563dacd1.svg";
export { ForwardRef as ReactComponent };